export function getProperty(object, propertyName) {
  if (propertyName.indexOf('.') > 0) {
    let property = object;
    propertyName.split('.').forEach(part => {
      if (property != null && property != undefined && part in property) {
        property = property[part];
      } else {
        property = null;
      }
    });
    return property;
  }

  return object[propertyName];
}

export function groupBy(objectArray, property) {
  return objectArray.reduce(function (acc, obj) {
    var key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
}

export function objectToArray(obj = {}) {
  const res = [];
  const keys = Object.keys(obj);
  for (let key of keys) {
    res.push([
      key, obj[key]
    ]);
  }
  return res;
}

export default {
  getProperty,
  groupBy,
  objectToArray,
};
